export default __webpack_public_path__ + "static/media/dark.eca673bd.png";